import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackSharp } from 'react-icons/io5';
import MenuModal from './Menumodal';
import logo from '../../Images/logo-4.png'; // Make sure logo exists
import { BASEAPIURL, token } from '../../env';

const Takeaway = ({ showBackButton = false }) => {
  const navigate = useNavigate();

  const [memberData, setMemberData] = useState({});
  const [memberImage, setMemberImage] = useState(logo);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleBack = () => navigate(-1);

  useEffect(() => {
    const memberID = sessionStorage.getItem('MemberID');
    if (!memberID) {
      setError('No MemberID found in sessionStorage.');
      setLoading(false);
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({ tokenData: token  }),
      redirect: 'follow',
    };

    fetch(`${BASEAPIURL}/MemberByID?MainID=${memberID}`, requestOptions)
      .then((res) => {
        if (!res.ok) throw new Error(`Error fetching member data: ${res.status}`);
        return res.json();
      })
      .then((result) => {
        const data = result?.data || {};
        setMemberData(data);
        if (data?.ImageBase64?.startsWith("data:image")) {
          setMemberImage(data.ImageBase64);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || 'Failed to fetch member data.');
        setLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid py-4">
      {showBackButton && (
        <>
          <div className="mb-4">
            <button
              className="btn btn-outline-secondary d-flex align-items-center"
              onClick={handleBack}
            >
              <IoArrowBackSharp className="me-2" />
              Back
            </button>
          </div>



          <div
          className="rounded-5"
          style={{
            minHeight: '50px',
            padding: '10px',
            marginTop: "50px",
            background:
              'linear-gradient(90deg, rgba(200, 182, 166, 1) 17%, rgba(217, 164, 117, 1) 66%, rgba(252, 176, 69, 1) 100%)',
          }}
        >
          <div className="row align-items-center">
            <div className="col-12 col-md-4 text-center">
              <img
                src={memberImage}
                className="rounded-circle border border-4"
                style={{
                  width: '150px',
                  height: '150px',
                  objectFit: 'cover',
                  marginTop: '-70px', // Half of image height to overlap
                  backgroundColor: 'white',
                }}
                alt="member"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
              />
            </div>
            <div className="col-12 col-md-4 text-center text-white mt-3">
              <h3>{memberData.MemName}</h3>
            </div>
            <div className="col-12 col-md-4 text-center text-white mt-3">
              <h5>{memberData.MemRegDt}</h5>
              <h5>{memberData.MemType}</h5>
              <h5 className="mt-2">{memberData.MemMSNO}</h5>
            </div>
          </div>
        </div>
        <br /><br /><br />


        </>

      )}

      <MenuModal />
    </div>
  );
};

export default Takeaway;
